import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const assignWidgetsToExperienceInputSchema_ = z.object({
  checkoutExperienceId: zExt.objectId(),
  widgetIds: z.array(zExt.objectId()),
});

export const assignWidgetsToExperience = {
  name: "assignWidgetsToExperience" as const,
  input: assignWidgetsToExperienceInputSchema_,
  output: z.object({ success: z.boolean() }),
};
